export default __webpack_public_path__ + "static/media/dots.0f836177.svg";